<!-- Test Recorder Interface -->
<div class="test-recorder-container" [style.--split.px]="viewModel.splitPx">
  <!-- Left Panel - Recording Controls & Steps -->
  <div class="left-panel">
    <!-- Header -->
    <header class="recorder-header">
      <h2><i class="pi pi-video"></i> {{ viewModel.mode === 'screen-capture' ? 'Start Screen Capture' : 'Test Recorder' }}</h2>
      <p-button icon="pi pi-times" [text]="true" [rounded]="true" severity="secondary" (click)="viewModel.onCancel()"
        pTooltip="Close recorder" tooltipPosition="left" class="close-btn"></p-button>
    </header>

    <!-- Tab View for Mode Switching -->
    <p-tabs [(value)]="activeTabIndex" *ngIf="!viewModel.isRecording">
      <p-tablist>
        <p-tab [value]="0" [disabled]="viewModel.mode === 'screen-capture'">Test Recorder</p-tab>
        <p-tab [value]="1" [disabled]="viewModel.mode === 'test-recorder'">Start Screen Capture</p-tab>
      </p-tablist>
      <p-tabpanels>
      <!-- Test Recorder Tab -->
      <p-tabpanel [value]="0">
        <div class="recording-config">
          <p-card>
            <ng-template pTemplate="header">
              <div class="card-header">
                <i class="pi pi-cog"></i>
                <span>Recording Configuration</span>
              </div>
            </ng-template>

            <div class="config-form">
          <!-- Client (required) -->
          <div class="form-field">
            <label for="client">Client<span class="required">*</span></label>
            <p-select id="client"
                        [options]="viewModel.clientOptions"
                        [(ngModel)]="viewModel.clientId"
                        (onChange)="viewModel.onClientChange(); viewModel.fieldErrors['clientId'] = ''"
                        optionLabel="name"
                        optionValue="id"
                        [disabled]="viewModel.isRecording"
                        placeholder="Select Client"
                        [class.ng-invalid]="viewModel.fieldErrors['clientId']"
                        class="w-full"></p-select>
            <small class="p-error" *ngIf="viewModel.fieldErrors['clientId']">{{viewModel.fieldErrors['clientId']}}</small>
          </div>

          <!-- Package (required) -->
          <div class="form-field">
            <label for="package">Package<span class="required">*</span></label>
            <p-select id="package"
                        [options]="viewModel.packageOptions"
                        [(ngModel)]="viewModel.packageDefinitionId"
                        (onChange)="viewModel.onPackageChange(); viewModel.fieldErrors['packageDefinitionId'] = ''"
                        optionLabel="packageName"
                        optionValue="id"
                        [disabled]="viewModel.isRecording"
                        placeholder="Select Package"
                        [showClear]="!!viewModel.packageDefinitionId"
                        [class.ng-invalid]="viewModel.fieldErrors['packageDefinitionId']"
                        class="w-full"></p-select>
            <small class="p-error" *ngIf="viewModel.fieldErrors['packageDefinitionId']">{{viewModel.fieldErrors['packageDefinitionId']}}</small>
          </div>

          <!-- Test Type (required) -->
          <div class="form-field">
            <label for="testType">Test Type<span class="required">*</span></label>
            <p-select id="testType"
                        [options]="viewModel.testTypeOptions"
                        [(ngModel)]="viewModel.testTypeId"
                        (onChange)="viewModel.fieldErrors['testTypeId'] = ''"
                        optionLabel="referenceValue"
                        optionValue="id"
                        [disabled]="viewModel.isRecording || !viewModel.packageDefinitionId"
                        placeholder="Select Test Type"
                        [showClear]="!!viewModel.testTypeId"
                        [class.ng-invalid]="viewModel.fieldErrors['testTypeId']"
                        class="w-full"></p-select>
            <small class="p-error" *ngIf="viewModel.fieldErrors['testTypeId']">{{viewModel.fieldErrors['testTypeId']}}</small>
          </div>

          <!-- Functional Area (required) -->
          <div class="form-field">
            <label for="functionalArea">Functional Area<span class="required">*</span></label>
            <p-select id="functionalArea"
                        [options]="viewModel.filteredFunctionalAreas"
                        [(ngModel)]="viewModel.functionalAreaId"
                        (onChange)="viewModel.onFunctionalAreaChange(); viewModel.fieldErrors['functionalAreaId'] = ''"
                        optionLabel="name"
                        optionValue="id"
                        [disabled]="viewModel.isRecording || !viewModel.testTypeId"
                        placeholder="Select Functional Area"
                        [showClear]="!!viewModel.functionalAreaId"
                        [class.ng-invalid]="viewModel.fieldErrors['functionalAreaId']"
                        class="w-full"></p-select>
            <small class="p-error" *ngIf="viewModel.fieldErrors['functionalAreaId']">{{viewModel.fieldErrors['functionalAreaId']}}</small>
          </div>

          <!-- Scenario ID (required) -->
          <div class="form-field">
            <label for="scenarioId">Scenario ID<span class="required">*</span></label>
            <input pInputText id="scenarioId" [(ngModel)]="viewModel.scenarioIdField" placeholder="Enter scenario ID (e.g., AOOO1)" class="w-full"
              [disabled]="viewModel.isRecording" (input)="viewModel.fieldErrors['scenarioIdField'] = ''"
              [class.ng-invalid]="viewModel.fieldErrors['scenarioIdField']" />
            <small class="p-error" *ngIf="viewModel.fieldErrors['scenarioIdField']">{{viewModel.fieldErrors['scenarioIdField']}}</small>
          </div>

          <!-- Scenario Name (required) -->
          <div class="form-field">
            <label for="runName">Scenario Name<span class="required">*</span></label>
            <input pInputText id="runName" [(ngModel)]="viewModel.runName" placeholder="Enter scenario name" class="w-full"
              [disabled]="viewModel.isRecording" (input)="viewModel.fieldErrors['runName'] = ''"
              [class.ng-invalid]="viewModel.fieldErrors['runName']" />
            <small class="p-error" *ngIf="viewModel.fieldErrors['runName']">{{viewModel.fieldErrors['runName']}}</small>
          </div>

          <!-- Description -->
          <div class="form-field">
            <label for="description">Description</label>
            <input pInputText id="description" [(ngModel)]="viewModel.description" placeholder="Enter description"
              class="w-full" [disabled]="viewModel.isRecording" />
          </div>

          <div class="form-field">
            <label for="url">Starting URL <span class="required">*</span></label>
            <div class="url-input-group">
              <input pInputText id="url" [(ngModel)]="viewModel.url" placeholder="https://..." class="w-full"
                [disabled]="viewModel.isRecording" />
              <p-button icon="pi pi-external-link" (click)="viewModel.go()" [disabled]="viewModel.isRecording"
                severity="secondary" pTooltip="Navigate to URL"></p-button>
            </div>
          </div>

          <div class="action-buttons">
            <p-button [label]="viewModel.editRecordingId || viewModel.isCloneMode ? 'Re-record' : 'Start'" icon="pi pi-circle" severity="danger"
              (click)="viewModel.startRecording()" [disabled]="viewModel.isRecording || viewModel.isExecuting"
              class="start-btn"></p-button>
            <p-button label="Clear" icon="pi pi-trash" severity="secondary" (click)="viewModel.clearRun()"
              [disabled]="viewModel.isExecuting" class="play-btn"
              pTooltip="Discard current steps; then click Start Recording" tooltipPosition="left"></p-button>

            <p-button *ngIf="viewModel.liveSteps.length > 0 && !viewModel.isRecording && !viewModel.isExecuting"
              label="Play" icon="pi pi-play" severity="success" (click)="viewModel.playRecording()" class="play-btn"
              pTooltip="Execute the recorded steps" tooltipPosition="left"></p-button>
            <p-button *ngIf="viewModel.liveSteps.length > 0 && !viewModel.isRecording && viewModel.isExecuting"
              label="Stop" icon="pi pi-stop" severity="danger" (click)="viewModel.requestStopExecution()"
              class="play-btn" pTooltip="Stop after the current step" tooltipPosition="left"></p-button>
          </div>
            </div>
          </p-card>
        </div>
      </p-tabpanel>

      <!-- Start Screen Capture Tab -->
      <p-tabpanel [value]="1">
        <div class="screen-capture-config">
          <p-card>
            <ng-template pTemplate="header">
              <div class="card-header">
                <i class="pi pi-desktop"></i>
                <span>Screen Definition</span>
              </div>
            </ng-template>

            <div class="config-form">
              <!-- Capture Button -->
              <div class="capture-action">
                <p-button 
                  label="Capture Current Screen" 
                  icon="pi pi-camera" 
                  severity="info" 
                  (click)="viewModel.captureCurrentScreen()"
                  [disabled]="viewModel.isCapturingScreen"
                  [loading]="viewModel.isCapturingScreen"
                  pTooltip="Detect screen identifiers from browser"></p-button>
              </div>

              <!-- Screen Name (required) -->
              <div class="form-field">
                <label for="screenName">Screen Name<span class="required">*</span></label>
                <input pInputText id="screenName" [(ngModel)]="viewModel.screenName" placeholder="e.g., Home Page" class="w-full" />
              </div>

              <!-- Description -->
              <div class="form-field">
                <label for="screenDescription">Description</label>
                <textarea pTextarea id="screenDescription" [(ngModel)]="viewModel.screenDescription" 
                  placeholder="Brief description of this screen" rows="2" class="w-full"></textarea>
              </div>

              <!-- Minimum Match Count -->
              <div class="form-field">
                <label for="minMatch">Minimum Match Count<span class="required">*</span></label>
                <input type="number" pInputText id="minMatch" [(ngModel)]="viewModel.minMatch" min="1" class="w-full" />
                <small class="hint">Number of rules that must match to identify this screen (recommended: 2+)</small>
              </div>

              <!-- Match Rules Section -->
              <div class="section-label">Match Rules ({{ viewModel.matchRules.length }})</div>
              
              <div class="rules-list" *ngIf="viewModel.matchRules.length > 0">
                <div class="rule-item" *ngFor="let rule of viewModel.matchRules; let i = index">
                  <div class="rule-content">
                    <span class="rule-type">{{ viewModel.getRuleLabel(rule.type) }}</span>
                    <span class="rule-value">{{ viewModel.getRuleValue(rule) }}</span>
                  </div>
                  <div class="rule-actions">
                    <p-button icon="pi pi-pencil" [text]="true" severity="success" (click)="viewModel.showEditRuleDialog(i)" 
                      pTooltip="Edit rule"></p-button>
                    <p-button icon="pi pi-trash" [text]="true" severity="danger" (click)="viewModel.deleteRule(i)" 
                      pTooltip="Delete rule"></p-button>
                  </div>
                </div>
              </div>

              <!-- Inline Rule Form -->
              <div class="rule-form-inline" *ngIf="viewModel.showRuleDialog">
                <p-card>
                  <ng-template pTemplate="header">
                    <div class="card-header">
                      <i class="pi pi-plus-circle"></i>
                      <span>{{ viewModel.editingRuleIndex >= 0 ? 'Edit Match Rule' : 'Add Match Rule' }}</span>
                    </div>
                  </ng-template>

                  <div class="form-field">
                    <label for="ruleType">Rule Type<span class="required">*</span></label>
                    <p-select id="ruleType" 
                      [options]="ruleTypeOptions" 
                      [(ngModel)]="viewModel.ruleType"
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Select rule type"
                      class="w-full"></p-select>
                  </div>

                  <div class="form-field" *ngIf="viewModel.ruleType === 'element_exists'">
                    <label for="ruleSelector">Element automation-id<span class="required">*</span></label>
                    <input pInputText id="ruleSelector" [(ngModel)]="viewModel.ruleSelector" 
                      placeholder="e.g., BUTTON_SUBMIT" class="w-full" />
                  </div>

                  <div class="form-field" *ngIf="viewModel.ruleType === 'url_contains'">
                    <label for="ruleUrl">URL Fragment<span class="required">*</span></label>
                    <input pInputText id="ruleUrl" [(ngModel)]="viewModel.ruleUrl" 
                      placeholder="e.g., /dashboard" class="w-full" />
                  </div>

                  <div class="form-field" *ngIf="viewModel.ruleType !== 'element_exists' && viewModel.ruleType !== 'url_contains'">
                    <label for="ruleText">Text Content<span class="required">*</span></label>
                    <input pInputText id="ruleText" [(ngModel)]="viewModel.ruleText" 
                      placeholder="Text to match" class="w-full" />
                  </div>

                  <div class="form-actions">
                    <p-button label="Cancel" icon="pi pi-times" severity="secondary" 
                      (click)="viewModel.showRuleDialog = false"></p-button>
                    <p-button label="Save" icon="pi pi-check" severity="success" 
                      (click)="viewModel.saveRule()"></p-button>
                  </div>
                </p-card>
              </div>

              <p-button label="Add Rule" icon="pi pi-plus" severity="secondary" 
                (click)="viewModel.showAddRuleDialog()" [disabled]="viewModel.showRuleDialog"
                class="add-rule-btn"></p-button>

              <!-- Fallback Steps Section -->
              <div class="section-label">Fallback Navigation Steps ({{ viewModel.liveSteps.length }})</div>
              <small class="hint">Record the steps needed to navigate TO this screen from the application start</small>
              
              <div class="fallback-actions">
                <p-button 
                  *ngIf="!isRecordingFallback && viewModel.liveSteps.length === 0"
                  label="Record Fallback Steps" 
                  icon="pi pi-circle" 
                  severity="warning" 
                  (click)="viewModel.startFallbackRecording()"></p-button>
                <p-button 
                  *ngIf="!isRecordingFallback && viewModel.liveSteps.length > 0"
                  label="Re-record Fallback Steps" 
                  icon="pi pi-refresh" 
                  severity="warning" 
                  (click)="viewModel.startFallbackRecording()"></p-button>
              </div>
              
              <small class="hint" *ngIf="viewModel.liveSteps.length > 0">View captured steps below in the "Captured Steps" section</small>
            </div>
          </p-card>
        </div>
      </p-tabpanel>
      </p-tabpanels>
    </p-tabs>

    <!-- Recording Configuration (shown when recording - no tab wrapping) -->
    <div class="recording-config" *ngIf="viewModel.isRecording">
      <p-card>
        <ng-template pTemplate="header">
          <div class="card-header">
            <i class="pi pi-cog"></i>
            <span>{{ viewModel.mode === 'screen-capture' ? 'Recording Fallback Steps' : 'Recording Configuration' }}</span>
          </div>
        </ng-template>
      </p-card>
    </div>

    <!-- Recording Controls (when recording) -->
    <div class="recording-controls" *ngIf="viewModel.isRecording">
      <p-card>
        <ng-template pTemplate="header">
          <div class="recording-status">
            <div class="status-indicator">
              <i class="pi pi-circle blink" [class.paused]="viewModel.isPaused"></i>
              <span class="status-text">{{ viewModel.isPaused ? 'PAUSED' : 'RECORDING' }}</span>
            </div>
            <div class="run-info">
              <strong>{{ viewModel.runName }}</strong>
            </div>
          </div>
        </ng-template>

        <div class="control-buttons">
          <p-button [label]="viewModel.isPaused ? 'Resume' : 'Pause'"
            [icon]="viewModel.isPaused ? 'pi pi-play' : 'pi pi-pause'" severity="warning"
            (click)="viewModel.pauseResumeRecording()" class="control-btn"></p-button>

          <p-button label="Stop" icon="pi pi-stop" severity="danger" (click)="viewModel.stopRecording()"
            class="control-btn"></p-button>

          <p-button label="Cancel" icon="pi pi-times" severity="secondary" (click)="viewModel.cancel()"
            class="control-btn"></p-button>

          <p-button label="Clear" icon="pi pi-trash" severity="secondary" (click)="viewModel.clearRun()"
            class="control-btn" pTooltip="Discard current steps; then click Start Recording"></p-button>
        </div>

        <div class="recording-stats">
          <p-chip [label]="'Steps: ' + viewModel.liveSteps.length" icon="pi pi-list"></p-chip>
          <p-chip
            [label]="'Started: ' + (viewModel.currentSession?.recordedAt ? viewModel.getFormattedTime(viewModel.currentSession.recordedAt) : '')"
            icon="pi pi-clock"></p-chip>
          <p-chip label="Ctrl+Hover to capture hover step" icon="pi pi-eye" styleClass="hover-hint-chip"></p-chip>
        </div>
      </p-card>
    </div>

    <!-- Add Verification (Tabbed) - Hidden in screen capture mode -->
    <div class="verification-section" *ngIf="viewModel.mode !== 'screen-capture'">
      <p-card>
        <ng-template pTemplate="header">
          <div class="card-header">
            <i class="pi pi-shield-check"></i>
            <span>Add Verification</span>
          </div>
        </ng-template>

        <p-tabs value="0" [scrollable]="true">
          <p-tablist>
            <p-tab value="0">Element</p-tab>
            <p-tab value="1">Page Text</p-tab>
            <p-tab value="2">Label + Value</p-tab>
            <p-tab value="3">Table Validation</p-tab>
            <p-tab value="4">Element Absence</p-tab>
          </p-tablist>
          <p-tabpanels>
          <!-- Element tab -->
          <p-tabpanel value="0">
            <div class="verification-form">
              <div class="verify-row">
                <div class="verify-field">
                  <label>
                    Element to verify
                    <i class="pi pi-info-circle info"
                      pTooltip="This is the last element you interacted with while recording. Click any element in the browser to update this target."
                      tooltipPosition="top"></i>
                  </label>
                  <div class="target-badge">
                    <i class="pi pi-bullseye"></i>
                    <span>{{ viewModel.verifyTargetLabel }}</span>
                  </div>
                  <small class="hint">Click an element in the browser to change the target</small>
                  <small class="details" *ngIf="viewModel.verifyTargetDetails">{{ viewModel.verifyTargetDetails
                    }}</small>
                </div>
              </div>

              <div class="verify-row">
                <div class="verify-field">
                  <label for="operator">Operator</label>
                  <select id="operator" [(ngModel)]="viewModel.verifyOperator" class="native-select">
                    <option value="contains">contains</option>
                    <option value="containsAll">contains all (order-insensitive)</option>
                    <option value="equals">equals</option>
                    <option value="matches">matches (regex)</option>
                    <option value="is">is</option>
                  </select>
                </div>

                <div class="verify-field flex-1">
                  <label for="expected">Expected (optional)</label>
                  <input pInputText id="expected" [(ngModel)]="viewModel.verifyExpected"
                    placeholder="Leave blank to verify visible" />
                </div>
              </div>

              <div class="verify-actions">
                <p-button label="Add Verify" icon="pi pi-check" severity="success"
                  (click)="viewModel.addVerification(false)"
                  [disabled]="!viewModel.verifyTargetLabel || viewModel.verifyTargetLabel==='—'" />
                <p-button label="Add Assert" icon="pi pi-verified" severity="info"
                  (click)="viewModel.addVerification(true)"
                  [disabled]="!viewModel.verifyTargetLabel || viewModel.verifyTargetLabel==='—'" />
              </div>
            </div>
          </p-tabpanel>

          <!-- Page Text tab -->
          <p-tabpanel value="1">
            <div class="verification-form">
              <div class="verify-row">
                <div class="verify-field flex-1">
                  <label for="pageText">Text to find on page</label>
                  <input pInputText id="pageText" [(ngModel)]="viewModel.pageVerifyText"
                    placeholder="e.g., Firstname or Firstname : Test" />
                  <small class="hint">Validates presence anywhere in page content</small>
                </div>
              </div>

              <div class="verify-actions">
                <p-button label="Add Verify" icon="pi pi-check" severity="success"
                  (click)="viewModel.addPageTextVerification(false)"
                  [disabled]="!viewModel.pageVerifyText || !viewModel.pageVerifyText.trim().length" />
                <p-button label="Add Assert" icon="pi pi-verified" severity="info"
                  (click)="viewModel.addPageTextVerification(true)"
                  [disabled]="!viewModel.pageVerifyText || !viewModel.pageVerifyText.trim().length" />
              </div>
            </div>
          </p-tabpanel>

          <!-- Label + Value tab -->
          <p-tabpanel value="2">
            <div class="verification-form">
              <div class="verify-row">
                <div class="verify-field flex-1">
                  <label for="labelText">Label</label>
                  <input pInputText id="labelText" [(ngModel)]="viewModel.labelVerifyLabel"
                    placeholder="e.g., Manage Basis Total" />
                </div>
              </div>

              <div class="verify-row">
                <div class="verify-field">
                  <label for="labelOp">Operator</label>
                  <select id="labelOp" [(ngModel)]="viewModel.labelVerifyOperator" class="native-select">
                    <option value="contains">contains</option>
                    <option value="equals">equals</option>
                    <option value="matches">matches (regex)</option>
                  </select>
                </div>
                <div class="verify-field flex-1">
                  <label for="labelExpected">Expected</label>
                  <input pInputText id="labelExpected" [(ngModel)]="viewModel.labelVerifyExpected"
                    placeholder="e.g., No" />
                </div>
              </div>

              <small class="hint">For checkboxes, use <strong>checked</strong> or <strong>unchecked</strong> as the expected value.</small>

              <div class="verify-actions">
                <p-button label="Add Verify" icon="pi pi-check" severity="success"
                  (click)="viewModel.addLabelValueVerification(false)"
                  [disabled]="!viewModel.labelVerifyLabel || !viewModel.labelVerifyLabel.trim().length || !viewModel.labelVerifyExpected || !viewModel.labelVerifyExpected.trim().length" />
                <p-button label="Add Assert" icon="pi pi-verified" severity="info"
                  (click)="viewModel.addLabelValueVerification(true)"
                  [disabled]="!viewModel.labelVerifyLabel || !viewModel.labelVerifyLabel.trim().length || !viewModel.labelVerifyExpected || !viewModel.labelVerifyExpected.trim().length" />
              </div>
            </div>
          </p-tabpanel>

          <!-- Table Validation tab -->
          <p-tabpanel value="3">
            <div class="verification-form">
              <!-- Phase 1: Discover & Select Table -->
              <div *ngIf="!viewModel.tableValidationActive" class="verify-row">
                <div class="verify-field flex-1">
                  <label>Step 1: Find Tables</label>
                  <p-button label="Discover Tables" icon="pi pi-search" severity="secondary"
                    (click)="viewModel.discoverTables()"
                    [disabled]="viewModel.isDiscoveringTables"
                    [loading]="viewModel.isDiscoveringTables" />
                  <small class="hint">Scan the current page for all visible tables</small>
                </div>
              </div>
              <div *ngIf="!viewModel.tableValidationActive && viewModel.availableTables.length > 0" class="verify-row">
                <div class="verify-field flex-1">
                  <label>Step 2: Select Table</label>
                  <p-select [options]="viewModel.availableTables"
                    [(ngModel)]="viewModel.selectedTableIndex"
                    optionLabel="label" optionValue="index"
                    placeholder="Select a table to validate"
                    styleClass="w-full"
                    (onChange)="viewModel.onTableSelected()">
                    <ng-template let-item pTemplate="item">
                      <span>{{ item.label }} ({{ item.columnCount }} cols, {{ item.rowCount }} rows)</span>
                    </ng-template>
                    <ng-template let-item pTemplate="selectedItem">
                      <span>{{ item.label }} ({{ item.columnCount }} cols, {{ item.rowCount }} rows)</span>
                    </ng-template>
                  </p-select>
                </div>
              </div>
              <div *ngIf="!viewModel.tableValidationActive && viewModel.availableTables.length > 0" class="verify-row">
                <div class="verify-field flex-1">
                  <label>Step 3: Capture Table</label>
                  <p-button label="Capture Selected Table" icon="pi pi-table" severity="primary"
                    (click)="viewModel.captureTable()"
                    [disabled]="viewModel.isCapturingTable || viewModel.selectedTableIndex < 0"
                    [loading]="viewModel.isCapturingTable" />
                  <small class="hint">Capture columns and start adding validations</small>
                </div>
              </div>

              <!-- Phase 2: Add Validations -->
              <div *ngIf="viewModel.tableValidationActive" class="table-validation-section">
                <!-- Table Info with Multi-Value Detection -->
                <div class="table-info">
                  <h4>
                    <i class="pi pi-table"></i> {{ viewModel.tableInfo?.tableId || 'Table' }} ({{ viewModel.tableInfo?.columnCount }} columns)
                    <p-button label="Change Table" icon="pi pi-refresh" [text]="true" size="small"
                      severity="secondary" (click)="viewModel.resetTableValidation()"></p-button>
                    <p-button label="Refresh Columns" icon="pi pi-sync" [text]="true" size="small"
                      severity="info" (click)="viewModel.refreshTableColumns()"></p-button>
                  </h4>
                  <div class="table-badges">
                    <p-chip *ngIf="viewModel.tableInfo?.hasPagination" label="Paginated" icon="pi pi-arrows-h" />
                    <p-chip *ngIf="viewModel.tableInfo?.hasMultiValueColumns" 
                      [label]="viewModel.tableInfo?.multiValueColumns?.length + ' Multi-Value Column(s)'" 
                      icon="pi pi-list"
                      severity="info"
                      styleClass="multi-value-chip"
                      [pTooltip]="getMultiValueTooltip()"
                      tooltipPosition="right" />
                  </div>
                </div>
                
                <!-- Multi-Value Detection Alert -->
                <div *ngIf="viewModel.tableInfo?.hasMultiValueColumns" class="multi-value-alert">
                  <i class="pi pi-info-circle"></i>
                  <div class="alert-content">
                    <strong>Multi-Value Columns Detected:</strong>
                    <span *ngFor="let col of viewModel.tableInfo?.multiValueColumns; let last = last">
                      {{ col.name }} ({{ col.valueCount }} values){{ last ? '' : ', ' }}
                    </span>
                  </div>
                  <small class="hint">
                    💡 Tip: When validating multi-value cells, all values will be normalized and combined for matching.
                  </small>
                </div>

                <!-- Validation Entries -->
                <div class="validation-entries">
                  <!-- Existing Validations -->
                  <div *ngFor="let validation of viewModel.currentValidations; let vi = index" class="validation-card">
                    <div class="validation-card-header">
                      <span class="row-badge">{{ vi + 1 }}</span>
                      <span class="validation-count">{{ validation.columnPairs.length }} checks</span>
                      <div class="row-actions">
                        <p-button icon="pi pi-pencil" severity="secondary" [text]="true" [rounded]="true" size="small"
                          (click)="viewModel.editValidationEntry(vi)" pTooltip="Edit" tooltipPosition="left"></p-button>
                        <p-button icon="pi pi-trash" [text]="true" severity="danger" size="small"
                          (click)="viewModel.removeValidation(vi)" tooltipPosition="left"
                          pTooltip="Remove this validation" />
                      </div>
                    </div>
                    <div class="validation-card-body">
                      <div *ngFor="let pair of validation.columnPairs" class="validation-pair">
                        <div class="validation-pair-label">
                          {{ pair.column }} <span class="pair-operator" *ngIf="pair.operator">({{ pair.operator }})</span>
                        </div>
                        <div class="validation-pair-value">{{ pair.value }}</div>
                      </div>
                    </div>
                  </div>

                  <!-- New Validation Entry Form -->
                  <div class="new-validation-form">
                    <h5>Add New Validation</h5>
                    <div class="column-value-pairs">
                      <div *ngFor="let pair of viewModel.newValidationPairs; let pi = index" class="pair-entry">
                        <select [(ngModel)]="pair.column" class="native-select column-select">
                          <option value="">Select Column</option>
                          <option *ngFor="let col of viewModel.tableInfo?.columnNames" [value]="col">{{ col }}</option>
                        </select>
                        <select [(ngModel)]="pair.operator" class="native-select operator-select" 
                          [pTooltip]="getOperatorTooltip(pair.operator)" tooltipPosition="top">
                          <option value="equals">Equals</option>
                          <option value="contains">Contains</option>
                          <option value="notEquals">Not Equals</option>
                          <option value="notContains">Not Contains</option>
                          <option value="startsWith">Starts With</option>
                          <option value="endsWith">Ends With</option>
                          <option value="greaterThan">Greater Than</option>
                          <option value="lessThan">Less Than</option>
                          <option value="isEmpty">Is Empty</option>
                          <option value="isNotEmpty">Is Not Empty</option>
                        </select>
                        <input pInputText [(ngModel)]="pair.value" 
                          placeholder="Expected value" 
                          class="value-input"
                          [disabled]="pair.operator === 'isEmpty' || pair.operator === 'isNotEmpty'" />
                        <p-button icon="pi pi-minus" [text]="true" severity="danger" size="small"
                          (click)="viewModel.removePair(pi)"
                          pTooltip="Remove column-value pair" />
                      </div>
                    </div>

                    <div class="form-actions">
                      <p-button label="Add Column-Value Pair" icon="pi pi-plus" [text]="true" severity="secondary"
                        (click)="viewModel.addColumnValuePair()" size="small" />
                    </div>

                    <div class="verify-actions mt-3">
                      <p-button label="Add Validation Entry" icon="pi pi-check" severity="success"
                        (click)="viewModel.addTableValidationEntry()"
                        [disabled]="!viewModel.canAddValidation()" />
                    </div>
                  </div>
                </div>

                <!-- Options -->
                <div class="validation-options mt-3">
                  <div class="option-row">
                    <label>
                      <input type="checkbox" [(ngModel)]="viewModel.tableSearchAllPages" 
                        (change)="viewModel.updateTableSearchAllPages()" />
                      Search across all pages
                    </label>
                  </div>
                </div>

                <!-- Summary and Actions -->
                <div class="validation-summary mt-3" *ngIf="viewModel.currentValidations.length > 0">
                  <p><strong>{{ viewModel.currentValidations.length }}</strong> validation(s) added</p>
                  <div class="summary-actions">
                    <p-button label="Save All Validations" icon="pi pi-save" severity="success"
                      (click)="viewModel.saveAllTableValidations()" 
                      pTooltip="Save all validations as a step" />
                    <p-button label="Reset" icon="pi pi-refresh" severity="secondary" [outlined]="true"
                      (click)="viewModel.resetTableValidation()" size="small" 
                      pTooltip="Clear all validations and start over" />
                  </div>
                </div>
              </div>
            </div>
          </p-tabpanel>

          <!-- Element Absence tab -->
          <p-tabpanel value="4">
            <div class="verification-form">
              <div class="info-banner mb-3">
                <i class="pi pi-info-circle"></i>
                <div>
                  <strong>Negative Validations</strong>
                  <p>Use this tab to verify elements or text that should NOT exist on the page.</p>
                </div>
              </div>

              <!-- Element Not Exist -->
              <div class="verify-section">
                <h5><i class="pi pi-ban"></i> Element Should Not Exist</h5>
                <div class="verify-row">
                  <div class="verify-field flex-1">
                    <label for="notExistElement">Element Name/Selector</label>
                    <input pInputText id="notExistElement" [(ngModel)]="viewModel.notExistElementName"
                      placeholder="e.g., error message, lock icon" />
                    <small class="hint">Name or description of element that should be absent</small>
                  </div>
                </div>

                <div class="verify-row">
                  <div class="verify-field">
                    <label for="absenceTimeout">Timeout (ms)</label>
                    <input pInputText id="absenceTimeout" type="number" [(ngModel)]="viewModel.absenceTimeout"
                      placeholder="3000" />
                    <small class="hint">Default: 3000ms for absence checks</small>
                  </div>
                </div>

                <div class="verify-actions">
                  <p-button label="Add Verify Not Exist" icon="pi pi-ban" severity="warning"
                    (click)="viewModel.addElementNotExist(false)"
                    [disabled]="!viewModel.notExistElementName || !viewModel.notExistElementName.trim().length" />
                  <p-button label="Add Assert Not Exist" icon="pi pi-exclamation-triangle" severity="danger"
                    (click)="viewModel.addElementNotExist(true)"
                    [disabled]="!viewModel.notExistElementName || !viewModel.notExistElementName.trim().length" />
                </div>
              </div>

              <p-divider></p-divider>

              <!-- Page Not Contain -->
              <div class="verify-section">
                <h5><i class="pi pi-file"></i> Page Should Not Contain Text</h5>
                <div class="verify-row">
                  <div class="verify-field flex-1">
                    <label for="notContainText">Text that should NOT appear</label>
                    <input pInputText id="notContainText" [(ngModel)]="viewModel.pageNotContainText"
                      placeholder="e.g., Error, Failed, Invalid" />
                    <small class="hint">Text that should be absent from page content</small>
                  </div>
                </div>

                <div class="verify-actions">
                  <p-button label="Add Verify" icon="pi pi-check" severity="warning"
                    (click)="viewModel.addPageNotContain(false)"
                    [disabled]="!viewModel.pageNotContainText || !viewModel.pageNotContainText.trim().length" />
                  <p-button label="Add Assert" icon="pi pi-verified" severity="danger"
                    (click)="viewModel.addPageNotContain(true)"
                    [disabled]="!viewModel.pageNotContainText || !viewModel.pageNotContainText.trim().length" />
                </div>
              </div>

              <p-divider></p-divider>

              <!-- Table Not Contains -->
              <div class="verify-section">
                <h5><i class="pi pi-table"></i> Table Should Not Contain Value</h5>
                <div class="verify-row">
                  <div class="verify-field flex-1">
                    <label for="tableNotContain">Value that should NOT be in table</label>
                    <input pInputText id="tableNotContain" [(ngModel)]="viewModel.tableNotContainText"
                      placeholder="e.g., Deleted, Inactive" />
                    <small class="hint">Value that should be absent from any table cell</small>
                  </div>
                </div>

                <div class="verify-row">
                  <div class="verify-field">
                    <label>
                      <input type="checkbox" [(ngModel)]="viewModel.tableNotContainSearchAllPages" />
                      Search all pages
                    </label>
                    <small class="hint">Validate absence across paginated tables</small>
                  </div>
                </div>

                <div class="verify-actions">
                  <p-button label="Add Table Not Contains" icon="pi pi-ban" severity="warning"
                    (click)="viewModel.addTableNotContains()"
                    [disabled]="!viewModel.tableNotContainText || !viewModel.tableNotContainText.trim().length" />
                </div>
              </div>

              <p-divider></p-divider>

              <!-- Column Not Contains -->
              <div class="verify-section">
                <h5><i class="pi pi-bars"></i> Column Should Not Contain Value</h5>
                <div class="verify-row">
                  <div class="verify-field">
                    <label for="columnNotContainName">Column Name</label>
                    <input pInputText id="columnNotContainName" [(ngModel)]="viewModel.columnNotContainName"
                      placeholder="e.g., Status, Type" />
                  </div>

                  <div class="verify-field flex-1">
                    <label for="columnNotContainValue">Value that should NOT be in column</label>
                    <input pInputText id="columnNotContainValue" [(ngModel)]="viewModel.columnNotContainValue"
                      placeholder="e.g., Error, Pending" />
                  </div>
                </div>

                <div class="verify-row">
                  <div class="verify-field">
                    <label>
                      <input type="checkbox" [(ngModel)]="viewModel.columnNotContainSearchAllPages" />
                      Search all pages
                    </label>
                    <small class="hint">Validate absence across paginated tables</small>
                  </div>
                </div>

                <div class="verify-actions">
                  <p-button label="Add Column Not Contains" icon="pi pi-ban" severity="warning"
                    (click)="viewModel.addColumnNotContains()"
                    [disabled]="!viewModel.columnNotContainName || !viewModel.columnNotContainName.trim().length || !viewModel.columnNotContainValue || !viewModel.columnNotContainValue.trim().length" />
                </div>
              </div>
            </div>
          </p-tabpanel>
          </p-tabpanels>
        </p-tabs>
      </p-card>
    </div>

    <!-- Live Steps Display -->
    <div class="live-steps-section">
      <p-card>
        <ng-template pTemplate="header">
          <div class="card-header">
            <i class="pi pi-list"></i>
            <span>Captured Steps ({{ viewModel.liveSteps.length }})</span>
            <span class="spacer"></span>
          </div>
        </ng-template>

        <div class="steps-container">
          <div *ngIf="viewModel.liveSteps.length === 0" class="no-steps">
            <i class="pi pi-info-circle"></i>
            <p>No steps captured yet. {{ viewModel.isRecording ? 'Perform actions in the browser to capture steps.' :
              'Start recording to begin.' }}</p>
          </div>

          <div *ngIf="viewModel.liveSteps.length > 0" class="steps-list">
            <div *ngFor="let step of viewModel.liveSteps; let i = index; trackBy: viewModel.trackStepBy" class="step-item"
              [class.latest]="i === viewModel.liveSteps.length - 1"
              [class.executing]="viewModel.currentExecutingStep === i" [class.executed]="viewModel.executedSteps.has(i)"
              [class.failed]="viewModel.failedSteps.has(i)" [class.optional]="step['optional']">
              <div class="step-header">
                <span class="step-number">{{ i + 1 }}</span>

                <!-- Execution status icon -->
                <i *ngIf="viewModel.currentExecutingStep === i" class="pi pi-spin pi-spinner execution-icon"></i>
                <i *ngIf="viewModel.executedSteps.has(i) && !viewModel.failedSteps.has(i)"
                  class="pi pi-check-circle execution-icon success"></i>
                <i *ngIf="viewModel.failedSteps.has(i)" class="pi pi-times-circle execution-icon error"></i>

                <p-tag [value]="step.action" [severity]="viewModel.getActionSeverity(step.action)"
                  [icon]="'pi ' + viewModel.getActionIcon(step.action)"></p-tag>

                <span class="step-actions" *ngIf="!viewModel.isExecuting">
                  <p-button icon="pi pi-play" severity="secondary" [text]="true" [rounded]="true" size="small"
                    (click)="viewModel.runSingleStep(i)" pTooltip="Run this step" tooltipPosition="left"></p-button>
                  <p-button icon="pi pi-pencil" severity="secondary" [text]="true" [rounded]="true" size="small"
                    (click)="step.action === 'verifyTableMultiple' ? viewModel.editTableValidation(i) : viewModel.openEditMenu($event, i)"
                    pTooltip="Edit" tooltipPosition="left"></p-button>
                  <p-button icon="pi pi-copy" severity="secondary" [text]="true" [rounded]="true" size="small"
                    (click)="viewModel.cloneStep(i)" pTooltip="Copy step" tooltipPosition="left"></p-button>
                  <p-button icon="pi pi-arrow-up" severity="secondary" [text]="true" [rounded]="true" size="small"
                    (click)="viewModel.moveStepUp(i)" pTooltip="Move up" tooltipPosition="left"
                    *ngIf="i > 0"></p-button>
                  <p-button icon="pi pi-arrow-down" severity="secondary" [text]="true" [rounded]="true" size="small"
                    (click)="viewModel.moveStepDown(i)" pTooltip="Move down" tooltipPosition="left"
                    *ngIf="i < viewModel.liveSteps.length - 1"></p-button>
                  <p-button icon="pi pi-plus" severity="secondary" [text]="true" [rounded]="true" size="small"
                    (click)="viewModel.openAddMenu(i)" pTooltip="Add step" tooltipPosition="left"></p-button>
                  <p-button [icon]="step['optional'] ? 'pi pi-question-circle' : 'pi pi-exclamation-circle'"
                    [severity]="step['optional'] ? 'warning' : 'secondary'" [text]="true" [rounded]="true" size="small"
                    (click)="viewModel.toggleOptional(i)"
                    [pTooltip]="step['optional'] ? 'Optional (skip on failure)' : 'Required (stop on failure)'"
                    tooltipPosition="left"></p-button>
                  <p-button icon="pi pi-trash" severity="secondary" [text]="true" [rounded]="true" size="small"
                    (click)="viewModel.deleteStep(i, $event)" pTooltip="Delete step" tooltipPosition="left"></p-button>
                </span>
              </div>

              <div class="step-description">
                {{ step.description }}
              </div>

              <!-- Inline edit form (keeps layout within card and never covers browser view) -->
              <div class="inline-edit" *ngIf="viewModel.editMenuIndex === i">
                <div class="inline-edit-grid">
                  <div *ngIf="step.action === 'click' || step.action === 'select'" class="field-group">
                    <label>Target text</label>
                    <input pInputText [(ngModel)]="viewModel.editTargetText"
                      placeholder="e.g., Alex Flye (ID-01010) ..." />
                    <div class="actions">
                      <p-button label="Save" icon="pi pi-check" (click)="viewModel.saveEditTargetText(i)"
                        severity="success" />
                    </div>
                  </div>
                  <div *ngIf="step.action === 'check' || step.action === 'uncheck'" class="field-group">
                    <label>Tag Name</label>
                    <input pInputText [(ngModel)]="viewModel.editCheckTag"
                      placeholder="e.g., Benefits Canada" />
                    <div class="actions">
                      <p-button label="Save" icon="pi pi-check" (click)="viewModel.saveEditCheckData(i)"
                        severity="success" />
                    </div>
                  </div>
                  <div *ngIf="step.value !== undefined" class="field-group">
                    <label>Value<span *ngIf="step.action === 'wait'"> (ms)</span></label>
                    <input pInputText [(ngModel)]="viewModel.editValue"
                      [placeholder]="step.action === 'wait' ? 'Enter time in ms' : 'Expected/filled value'" />
                    <div class="actions">
                      <p-button label="Save" icon="pi pi-check" (click)="viewModel.saveEditValue(i)"
                        severity="success" />
                    </div>
                  </div>
                </div>
              </div>

              <!-- Inline add menu -->
              <div class="add-menu" *ngIf="viewModel.addMenuIndex === i">
                <p-button label="Record New Step" icon="pi pi-circle" [text]="true" size="small"
                  (click)="viewModel.recordNewStepAfter(i)"></p-button>
                <p-button label="Add Wait" icon="pi pi-clock" [text]="true" size="small"
                  (click)="viewModel.openWaitMenu(i)"></p-button>
                <p-button label="Press Enter" icon="pi pi-sign-in" [text]="true" size="small"
                  (click)="viewModel.addPressEnterAfter(i)"></p-button>
                <p-button label="Add Verify" icon="pi pi-check-circle" [text]="true" size="small"
                  (click)="viewModel.scrollToVerification(i)"></p-button>
              </div>

              <!-- Inline wait menu -->
              <div class="wait-menu" *ngIf="viewModel.waitMenuIndex === i">
                <span class="detail-label">Wait before:</span>
                <div class="wait-options">
                  <span class="custom-input">
                    <input pInputText type="number" min="0" [(ngModel)]="viewModel.waitCustomMs"
                      placeholder="Enter time in ms" class="w-40" />
                    <span class="unit"> in (ms)</span>
                    <p-button label="Add" [text]="true" size="small"
                      (click)="viewModel.addWaitBeforeFromCustom(i)"></p-button>
                    <p-button label="Close" [text]="true" size="small" (click)="viewModel.closeWaitMenu()"></p-button>
                  </span>
                </div>
              </div>

              <div class="step-details" *ngIf="step.value || step['displayValue']">
                <span class="detail-label">Value:</span>
                <code>{{ step.action === 'wait' ? (step.value + ' ms') : viewModel.getMaskedValue(step) }}</code>
              </div>

              <div class="step-details" *ngIf="step.text && (step.action === 'click' || step.action === 'select')">
                <span class="detail-label">Target:</span>
                <code>{{ step.text }}</code>
              </div>

              <div class="step-details"
                *ngIf="step.selector && (step.action === 'verify' || step.action === 'assert') && step.selector['operator']">
                <span class="detail-label">Operator:</span>
                <code>{{ step.selector['operator'] }}</code>
              </div>

              <!-- Table validation details (before execution) -->
              <div class="step-details table-validation-details"
                *ngIf="step.action === 'verifyTableMultiple' && step.selector?.['validations']?.length">
                <span class="detail-label">Validations:</span>
                <div *ngFor="let v of step.selector['validations']; let vi = index" class="table-validation-detail">
                  <code>Row {{ vi + 1 }}: {{ viewModel.formatValidationEntry(v) }}</code>
                </div>
              </div>

              <!-- Inline verification details (VERIFY only) -->
              <div class="verify-result"
                   *ngIf="step.action === 'verify' && (viewModel.stepResults.get(i)?.result?.assertion || viewModel.stepResults.get(i)?.assertion) as assertion"
                   [class.passed]="assertion?.passed"
                   [class.failed]="assertion && assertion.passed === false">
                <div class="verify-header">
                  <i class="pi" [ngClass]="assertion?.passed ? 'pi-check-circle success' : 'pi-times-circle error'"></i>
                  <strong>{{ assertion?.passed ? 'Verification Passed' : 'Verification Failed' }}</strong>
                </div>
                <div class="verify-fields">
                  <div class="vf-row">
                    <span class="detail-label">Type:</span>
                    <code>{{ assertion?.type || 'text' }}</code>
                  </div>
                  <div class="vf-row" *ngIf="assertion?.operator">
                    <span class="detail-label">Operator:</span>
                    <code>{{ assertion?.operator }}</code>
                  </div>
                  <div class="vf-row">
                    <span class="detail-label">Expected:</span>
                    <code>{{ assertion?.expected }}</code>
                  </div>
                  <div class="vf-row">
                    <span class="detail-label">Actual:</span>
                    <code>{{ assertion?.actual || '(none)' }}</code>
                  </div>
                </div>
              </div>

              <!-- Table Multiple Validation Results -->
              <div class="table-validation-result"
                   *ngIf="step.action === 'verifyTableMultiple' && (viewModel.stepResults.get(i)?.result?.assertion || viewModel.stepResults.get(i)?.assertion) as assertion"
                   [class.passed]="assertion?.passed"
                   [class.failed]="assertion && assertion.passed === false">
                <div class="verify-header">
                  <i class="pi" [ngClass]="assertion?.passed ? 'pi-check-circle success' : 'pi-times-circle error'"></i>
                  <strong>{{ assertion?.passed ? 'All Validations Passed' : 'Some Validations Failed' }}</strong>
                  <span class="validation-summary">{{ assertion?.passedCount }}/{{ assertion?.totalValidations }}</span>
                </div>
                
                <!-- Failed Validations Expandable List -->
                <div class="failed-validations" *ngIf="assertion?.failedValidations && assertion.failedValidations.length > 0">
                  <details>
                    <summary>
                      <strong>{{ assertion.failedCount }} Failed Validation(s)</strong>
                      <i class="pi pi-chevron-down"></i>
                    </summary>
                    <div class="validation-list">
                      <div *ngFor="let failed of assertion.failedValidations; let fi = index" class="failed-item">
                        <div class="failed-header">
                          <span class="failed-number">{{ fi + 1 }}</span>
                          <span class="failed-reason">{{ failed.reason || 'Not found' }}</span>
                        </div>
                        <div class="failed-criteria">
                          <div *ngFor="let pair of failed.validation?.columnPairs" class="criteria-pair">
                            <strong>{{ pair.column }}:</strong> {{ pair.value }}
                          </div>
                        </div>
                        <div class="failed-meta" *ngIf="failed.pagesSearched">
                          <small>Searched {{ failed.pagesSearched }} page(s)</small>
                        </div>
                      </div>
                    </div>
                  </details>
                </div>

                <!-- Passed Validations Summary (collapsed by default) -->
                <div class="passed-validations" *ngIf="assertion?.results && assertion.passedCount > 0">
                  <details>
                    <summary>
                      <strong>{{ assertion.passedCount }} Passed Validation(s)</strong>
                      <i class="pi pi-chevron-down"></i>
                    </summary>
                    <div class="validation-list">
                      <div *ngFor="let result of assertion.results; let ri = index" class="passed-item" [hidden]="!result.found">
                        <div class="passed-header">
                          <i class="pi pi-check success"></i>
                          <span>Found on {{ result.page ? 'page ' + result.page : 'current page' }} at row {{ result.rowIndex }}</span>
                        </div>
                        <div class="passed-criteria">
                          <div *ngFor="let pair of result.validation?.columnPairs" class="criteria-pair">
                            <strong>{{ pair.column }}:</strong> {{ pair.value }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </details>
                </div>
              </div>

              <div class="step-selector" *ngIf="step.selector && step.action !== 'wait'">
                <span class="detail-label">Selector:</span>
                <code class="selector-code">
                  {{ step.selector.automationId ? '[data-automation-id="' + step.selector.automationId + '"]' : 
                     step.selector.id ? '#' + step.selector.id : 
                     step.selector.css || 'name: ' + step.selector.name }}
                </code>
              </div>

              <!-- Error message if failed (hide for VERIFY; shown for others) -->
              <div class="step-error-message" *ngIf="viewModel.stepErrors.get(i) && step.action !== 'verify'">
                <div class="error-content">
                  <i class="pi pi-exclamation-triangle error-icon"></i>
                  <div class="error-text">
                    <strong>Error:</strong>
                    <span>{{ viewModel.stepErrors.get(i) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </p-card>
    </div>

    <!-- Fixed Footer Actions -->
    <div class="fixed-footer-actions"
      *ngIf="viewModel.liveSteps.length > 0 && !viewModel.isRecording && !viewModel.isExecuting">
      <p-button 
        *ngIf="viewModel.mode === 'screen-capture'"
        label="Save" 
        icon="pi pi-save" 
        severity="success" 
        (click)="viewModel.saveScreen()" 
        [disabled]="!viewModel.screenName || viewModel.matchRules.length === 0"></p-button>
      <label *ngIf="viewModel.mode === 'test-recorder'"
        class="inline-flex items-center gap-1.5 mr-3 cursor-pointer text-xs text-purple-600 font-medium">
        <input type="checkbox" [(ngModel)]="viewModel.isSkeleton"
          class="w-3.5 h-3.5 accent-purple-600 cursor-pointer">
        Save as Template
      </label>
      <p-button
        *ngIf="viewModel.mode === 'test-recorder'"
        label="Save"
        icon="pi pi-save"
        severity="success"
        (click)="viewModel.saveRecording()"
        [disabled]="viewModel.isSaving"></p-button>
      <p-button label="Cancel" icon="pi pi-times" severity="warn" (click)="viewModel.onCancel()"></p-button>
    </div>
  </div>

  <!-- Resizable Gutter -->
  <div class="gutter" (mousedown)="viewModel.startDrag($event)"></div>

  <!-- Right Panel - Browser View (Electron renders here) -->
  <div class="right-panel"></div>
</div>